module.exports = __webpack_public_path__ + "static/media/Snapchat01.cc33eb33.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svgs/SocialMediaMenu/Snapchat01.svg
// module id = 331
// module chunks = 0